import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";

const UncollectedItems = ({ items, onItemClick }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(50px, 1fr))",
        gap: 1,
      }}
    >
      {items.map((item) => (
        <Box
          key={item.itemId}
          sx={{
            border: "1px solid #ccc",
            borderRadius: "8px",
            width: "50px",
            height: "50px",
            textAlign: "center",
            backgroundColor: "#e0e0e0", // Grey background for not collected items
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => onItemClick(item)}
        >
          <Box sx={{ position: "relative" }}>
            <img
              src={item.imageUrl}
              alt={item.name}
              style={{
                width: "45px",
                height: "45px",
                objectFit: "contain",
                filter: "grayscale(100%)", // Make the image grayscale
              }}
            />
            <Tooltip title={`${item.name} - Uncollected`}>
              <Typography
                variant="body2"
                sx={{
                  position: "absolute",
                  bottom: "0px",
                  right: "0px",
                  left: "0px",
                  fontWeight: "bold",
                  fontSize: "0.75rem",
                  color: "#000",
                  textShadow: `
                    -1px -1px 0 #fff,
                    1px -1px 0 #fff,
                    -1px 1px 0 #fff,
                    1px 1px 0 #fff
                  `,
                  padding: "2px",
                  borderRadius: "0 0 2px 2px",
                }}
              >
                N/A
              </Typography>
            </Tooltip>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default UncollectedItems;
